import { Editor } from 'domains/reporter/RichTextEditor/core';

import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import { PageTypes } from 'utils/pageTypes';
import { Key } from 'slate-react';
import {
  PointDeepLinkElement,
  SliceDeepLinkElement,
  StudyDeepLinkElement,
} from '../../slate-custom-types';

export const DEEP_LINK_PLUGIN_ID = 'deepLink' as const;
export type DeepLinkPluginID = typeof DEEP_LINK_PLUGIN_ID;

type SliceDeepLinkProps = {
  target: typeof PageTypes.VIEWER;
} & SliceDeepLinkElement;

type PointDeepLinkProps = {
  target: typeof PageTypes.VIEWER;
} & PointDeepLinkElement;

type StudyDeepLinkProps = {
  target: typeof PageTypes.VIEWER;
} & StudyDeepLinkElement;

export type DeepLink = SliceDeepLinkProps | PointDeepLinkProps | StudyDeepLinkProps;

export type DeepLinkPluginElement = EditorElement &
  DeepLink & {
    type: DeepLinkPluginID;
  };

export type DeepLinkPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: React.ComponentType<any>;
    ignoreMergeFieldsInNavigation?: boolean;
    isAutoFillComparisonEnabled?: boolean;
    onDeepLinkClick?: (element: DeepLinkPluginElement | null, editor: Editor | null) => void;
    onDeepLinkEditClick?: (element: DeepLinkPluginElement | null, editor: Editor | null) => void;
    getIsEditingStudyNode?: (key: Key) => boolean;
  }
>;

export type DeepLinkPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    DeepLinkPluginOptions & {
      pluginID: DeepLinkPluginID;
      pluginName: string;
      component: React.ComponentType<any>;
    }
>;

export type DeepLinkContexts = DeepLink['context'];
export type DeepLinkTargets = DeepLink['target'];
